<template>
    <div class="notifications">
        <div class="notification" v-for="notification in notifications" :key="notification.uuid">
            <div class="icon" :class="notification.type">
                <i v-if="notification.type === 'success'" class="mdi mdi-check"></i>
                <i v-if="notification.type === 'warning'" class="mdi mdi-error-outline"></i>
                <i v-if="notification.type === 'danger'" class="mdi mdi-close"></i>
                <i v-if="notification.type === 'info'" class="mdi mdi-info-outline"></i>
            </div>
            <div class="text" v-html="notification.text"></div>
            <div v-if="notification.closable" class="close" @click="close(notification)">&times;</div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
  data: () => ({
    notifications: [],
    uuid: 0,
  }),

  methods: {
    display(params) {
      if (typeof params === 'string') {
        params = { text: params };
      }

      // Build options
      const options = _.assign({
        type: 'info',
        text: '',
        timeout: 1800,
        closable: true,
        close: false,
      }, params, {
        uuid: ++this.uuid,
      });

      this.notifications.push(options);

      // Retreive the proper, reactive Vue instance
      const notification = _.last(this.notifications);

      // Apply timeout
      if (options.timeout > 0) {
        setTimeout(() => this.close(notification), options.timeout);
      }

      // Allow modifications later on
      return notification;
    },

    close(notification) {
      this.notifications.splice(_.findIndex(this.notifications, notification), 1);
    },
  },

  watch: {
    // Auto-close notifications when the "close" flag has been set
    notifications: {
      deep: true,
      handler(val) {
        // Filter creates a copy of the array, so we don't get concurrency issues
        _.each(_.filter(val, ['close', true]), this.close);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
    @import "~bootstrap-sass/assets/stylesheets/bootstrap/variables";
    @import "../../sass/variables";

    $color: desaturate(mix($kw-blue, black), 50%);

    .notifications {
        position: fixed;
        bottom: 15px;
        right: 15px;
        z-index: 9999999;

        background: darken($color, 2.5%);
        border-radius: 4px;
        overflow: hidden;
        color: #f2f2f2;

        width: 350px;
    }

    .notification {
        display: flex;
        align-items: stretch;

        &:last-child {
            .icon, .text, .close {
                border-bottom-width: 0;
            }
        }

        .icon {
            background-color: darken($color, 8%);
            padding: 8px 10px 0;

            i {
                font-size: 20px;
            }

            &.info    {  background-color: darken($brand-info, 15%);  }
            &.success {  background-color: darken($brand-success, 3%);  }
            &.warning {  background-color: darken($brand-warning, 10%);  }
            &.danger  {  background-color: darken($brand-danger, 3%);  }
        }

        .text, .close {
            border-bottom: 1px solid lighten($color, 8%);
        }

        .text {
            padding: 10px 15px;
            flex-grow: 1;
        }

        .close {
            opacity: 1;
            padding: 10px;
            text-shadow: none;
            color: rgba(white, .333);
            background-color: darken($color, 8%);
            border-bottom-color: $color;

            &:hover {
                color: rgba(white, .666);
            }
        }
    }

    @media (max-width: $screen-xs-max) {
        .notifications {
            bottom: 0;
            right: auto;
            border-radius: 0;
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/notifications/Notifications.vue